<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';
export default defineComponent({
  name: 'Recommendation',
  created () {
    window.addEventListener('resize', this.update);
    switch (this.$route.path) {
      case '/timeline/recommendation/0001':
        this.setFirstRoute('galaxy');
        break;
      case '/timeline/recommendation/0002':
        this.setFirstRoute('android');
        break;
      case '/timeline/recommendation/0003':
        this.setFirstRoute('ios');
        break;
      case '/timeline/recommendation/0004':
        this.setFirstRoute('xperia');
        break;
    }
  },
  methods: {
    ...mapActions([
      'setFirstRoute'
    ]),
    update () {
      Array.from(document.images).forEach((image: HTMLImageElement) => { image.style.height = '100%'; });
      const contentHeight = window.document.getElementById('app')?.offsetHeight + 'px';
      window.parent.postMessage({
        solutoHtmlInfo: { height: contentHeight }
      }, '*');
    },
    scroll () {
      window.parent.postMessage({
        solutoChangePage: true
      }, '*');
    }
  }
});
</script>

<template>
  <router-view :key="$route.fullPath" @load="update" @scroll="scroll"></router-view>
</template>

<style lang="scss" scoped>
</style>
